import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MarketingRouter } from '@/router';
import '@/styles/index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root missing');

createRoot(rootEl).render(
  <StrictMode>
    <MarketingRouter />
  </StrictMode>,
);
